/* eslint-disable */
import React, { useState } from 'react';
import Reports_Icons from '../icons/Reports_Icon';
import './Header.css';

export default function HeaderSelectionHistoryDrivers({ setFilterBy }) {
  const [selectedOption, setSelectedOption] = useState('GlobalStatementsDrivers');

  const handleOptionClick = (option) => {
    setFilterBy(option);
    setSelectedOption(option);
  };

  return (
    <div className="selection-grid">
      <button
        className={`selection-button ${
          selectedOption === 'GlobalStatementsDrivers' ? 'selected' : ''
        }`}
        onClick={() => handleOptionClick('GlobalStatementsDrivers')}
        disabled={selectedOption === 'GlobalStatementsDrivers'}
      >
        <Reports_Icons />
        <p className="Text-filter">Ver estados de cuenta globales</p>
      </button>
      <button
        className={`selection-button ${selectedOption === 'StatementsDrivers' ? 'selected' : ''}`}
        onClick={() => handleOptionClick('StatementsDrivers')}
        disabled={selectedOption === 'StatementsDrivers'}
      >
        <Reports_Icons />
        <p className="Text-filter">Ver estados de cuenta por conductor</p>
      </button>
      <button
        className={`selection-button ${selectedOption === 'Enviados' ? 'selected' : ''}`}
        onClick={() => handleOptionClick('Enviados')}
        disabled={selectedOption === 'Enviados'}
      >
        <Reports_Icons />
        <p className="Text-filter">Ver estados de cuenta enviados</p>
      </button>
      {/*       <button
        className={`selection-button ${selectedOption === 'Enviados' ? 'selected' : ''}`}
        onClick={() => handleOptionClick('Enviados')}
        disabled={selectedOption === 'Enviados'}
      >
        <Reports_Icons />
        <p className="Text-filter">Ver estados de cuenta enviados</p>
      </button> */}
    </div>
  );
}
